import { useState, useRef, useEffect } from "react";
import { useOutsideClick } from "@builder/hooks/useOutsideClick";
import OliverText, { TextProps } from "@builder/components/general/OliverText";
import "./style.scss";

type RenameWrapperProps = {
    text: string;
    setIsEditingState?: (isEditing: boolean) => void;
    onRename: (newName: string) => void;
    className?: string;
    inputStyle?: React.CSSProperties;
    textProps?: Omit<TextProps, "text">;
    style?: React.CSSProperties;
};

const RenameWrapper = ({ text: initialName, onRename, className = "", inputStyle, textProps, setIsEditingState, style }: RenameWrapperProps) => {
    const [isEditing, setIsEditing] = useState(false);
    const [tempName, setTempName] = useState(initialName);
    const wrapperRef = useRef<HTMLDivElement>(null);


    useEffect(() => {
        setTempName(initialName);
    }, [initialName]);

    const handleRename = () => {
        onRename(tempName.trim() || initialName);
        setIsEditing(false);
        setIsEditingState && setIsEditingState(false);
        
    };

    useOutsideClick(wrapperRef, () => {
        if (isEditing) handleRename();
    });

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        e.stopPropagation();
        if (e.key === "Enter") {
            handleRename();
        } else if (e.key === "Escape") {
            setTempName(initialName);
            setIsEditing(false);
            setIsEditingState && setIsEditingState(false);
        }
    };

    return (
        <div ref={wrapperRef} className={`rename-wrapper ${className}`} style={style}>
            {isEditing ? (
                <input
                    type="text"
                    className="rename-input"
                    value={tempName}
                    onChange={(e) => setTempName(e.target.value)}
                    onKeyDown={handleKeyDown}
                    autoFocus
                    style={inputStyle}
                />
            ) : (
                <span
                    onDoubleClick={() => {setIsEditing(true);(setIsEditingState && setIsEditingState(true))}} className="oliver-text-wrapper"
                    
                >
                    <OliverText
                       {...{
                        ...textProps,
                        text: tempName,
                        style: { lineHeight: "unset", ...textProps?.style }
                       }}
                       
                    />
                </span>
            )}
        </div>
    );
};

export default RenameWrapper;
